"use client"

import { useQuery } from "@tanstack/react-query"
import { queryKeys } from "@/shared/lib/query-keys"
import { getSubscriptionDetails } from "../actions"
import { useAuthStore } from "@/features/auth/store"

export function useSubscription() {
  const user = useAuthStore((s) => s.user)
  const userId = user?.id ?? ""
  const isPaidUser = !!user && user.subscription !== "free"

  const query = useQuery({
    queryKey: queryKeys.coins.subscription(userId),
    queryFn: async () => {
      const result = await getSubscriptionDetails()
      if (!result.success) throw new Error(result.error ?? "Failed to fetch subscription")
      return result.subscription ?? null
    },
    enabled: !!userId && isPaidUser,
    staleTime: 30_000,
  })

  return {
    subscription: query.data ?? null,
    isLoading: query.isLoading,
    refetch: query.refetch,
  }
}
